import { useEffect, useRef } from "react";
import { OTP_LENGTH } from "../constants";

function OtpBoxInput({ value, onChange, onSubmit, hasError, autoFocus }) {
	const inputRefs = useRef([]);
	const boxes = Array.from({ length: OTP_LENGTH }, (_, i) => value[i] || "");

	useEffect(() => {
		if (autoFocus) inputRefs.current[0]?.focus();
	}, [autoFocus]);

	const focusBox = (i) => inputRefs.current[i]?.focus();

	const handleChange = (i, e) => {
		const char = e.target.value
			.replace(/[^A-Za-z0-9]/g, "")
			.slice(-1)
			.toUpperCase();
		const next = [...boxes];
		next[i] = char;
		onChange(next.join(""));
		if (char && i < OTP_LENGTH - 1) focusBox(i + 1);
	};

	const handleKeyDown = (i, e) => {
		if (e.key === "Backspace") {
			e.preventDefault();
			const next = [...boxes];
			if (next[i]) {
				next[i] = "";
				onChange(next.join(""));
			} else if (i > 0) {
				next[i - 1] = "";
				onChange(next.join(""));
				focusBox(i - 1);
			}
		} else if (e.key === "ArrowLeft" && i > 0) {
			focusBox(i - 1);
		} else if (e.key === "ArrowRight" && i < OTP_LENGTH - 1) {
			focusBox(i + 1);
		} else if (e.key === "Enter") {
			e.preventDefault();
			onSubmit?.();
		}
	};

	const handlePaste = (e) => {
		e.preventDefault();
		const pasted = e.clipboardData
			.getData("text")
			.toUpperCase()
			.replace(/[^A-Z0-9]/g, "")
			.slice(0, OTP_LENGTH);
		onChange(pasted);
		focusBox(Math.min(pasted.length, OTP_LENGTH - 1));
	};

	return (
		<div className={`otp-boxes${hasError ? " otp-boxes--error" : ""}`}>
			{boxes.map((char, i) => (
				<input
					key={i}
					ref={(el) => {
						inputRefs.current[i] = el;
					}}
					type="text"
					inputMode="text"
					autoComplete={i === 0 ? "one-time-code" : "off"}
					maxLength={1}
					value={char}
					onChange={(e) => handleChange(i, e)}
					onKeyDown={(e) => handleKeyDown(i, e)}
					onPaste={handlePaste}
					onFocus={(e) => e.target.select()}
					className={`otp-box${char ? " otp-box--filled" : ""}${hasError ? " otp-box--error" : ""}`}
					aria-label={`Code digit ${i + 1}`}
				/>
			))}
		</div>
	);
}

export default OtpBoxInput;
